// import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import i18n from "./system/lang/lang.js";
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import GullKit from "./plugins/gull.kit.js";
import Breadcumb from "./components/breadcumb.vue";
import firebase from "firebase/app";
import { firebaseSettings } from "./data/config.js";
import InstantSearch from 'vue-instantsearch';
import { setLanguage } from "./system/api/api";
import { homeGetTheme, getMemberInfo } from "./system/request/api/api";

Vue.component('VueFontawesome', require('vue-fontawesome-icon/VueFontawesome.vue').default);
Vue.component("breadcumb", Breadcumb);

Vue.use(InstantSearch);
Vue.use(GullKit);
// Vuelidate is already registered inside GullKit

firebase.initializeApp(firebaseSettings);



Vue.config.productionTip = false;

new Vue({
  data() {
    return {
      isLoading: false,
      loggedIn: !!localStorage.getItem('currencyToken'),
      needRiskLevel: false,
      cannotUpgrade: true,
      userInfo: {
        premium_member:'',
        invest: 0,
        user_group_id: 0,
        point3: '',
        rank: {
          rank_name_en: ''
        },
        package: {
          price: 0,
        }
      },
      bankInfo: {},
      cryptoInfo: {},
      selectedWallet: '',
      currentAddress: '',
      username: '',
      memberList: [],
      country_code: '',
      countryOptions: [],
      countryDepositOptions: [],
      teamList: [],
      newsList: [],
      latestNews: [],
      packageList: [],
      bannerList: [],
      userPackages: [],
      assetInfo: {
        static_bonus: 0,
        special_bonus: 0,
        dynamic_bonus: 0,
        level_bonus: 0,
      },
      variant: 'success',
      modal: {
        title: "",
        msg: "",
        action: false,
        actionType: '',
        error: false,
      },
      defaultCountry: {},
      globalSetting: null,
      blockWithdraw: false,
      admin_replied: 0,
      selectedVoucher: {},
      selectedList: [],
      // every line gets all the fields the new cart page uses up front, so Vue tracks them
      // (lines saved by older versions had no tick box, game or variants)
      cartItems: (function () {
        let saved = [];
        try { saved = JSON.parse(localStorage.getItem('shopCart') || '[]') || []; } catch (e) { saved = []; }
        return saved.map((l) => Object.assign({ sku: '', variant: '', originalPrice: null, category: '', variants: [],
          available: null, inactive: false, item_id: l.id, variant_id: null }, l, { id: String(l.id), selected: l.selected !== false }));
      })(),
      buyNowItem: null,
      showedMsg: false,
    }
  },
  computed: {
    cartCount() {
      return this.cartItems.reduce((s, i) => s + i.qty, 0);
    },
  },
  watch: {
    "$i18n.locale": "setLang"
  },
  // the product-photo background (admin → Homepage → Product Theme): the last one known is used at
  // once so the photos do not flash, then the server says which is active now
  created() {
    let cached = null;
    try { cached = localStorage.getItem('nhItemTheme'); } catch (e) { cached = null; }
    this.applyItemTheme(cached);
    homeGetTheme()
      .then((res) => {
        const d = res && res.data;
        if (!d || d.status !== 1) return;
        const url = d.data && d.data.image ? d.data.image : null;
        this.applyItemTheme(url);
        try { if (url) localStorage.setItem('nhItemTheme', url); else localStorage.removeItem('nhItemTheme'); } catch (e) { /* private mode */ }
      })
      .catch(() => { /* keep whatever is showing */ });
  },
  methods: {
    // The signed-in member's details (tier, points, spend …) into $root.userInfo. The old header and
    // pages call this; it was missing, so they threw and never showed the member's tier / points.
    getInfo() {
      if (!localStorage.getItem('currencyToken')) return Promise.resolve(null);
      return getMemberInfo()
        .then((res) => {
          const d = res && res.data && res.data.data;
          if (d && d.username) {
            this.userInfo = Object.assign({}, this.userInfo, d);
            this.username = d.username;
          }
          return d || null;
        })
        .catch(() => null);
    },
    // CSS variable --nh-item-bg on <html>: newsite.css and the product boxes draw it behind each photo
    applyItemTheme(url) {
      const root = document.documentElement;
      if (url) root.style.setProperty('--nh-item-bg', 'url("' + String(url).replace(/"/g, '%22') + '")');
      else root.style.removeProperty('--nh-item-bg');
    },
    changeLan(lan) {
      if (lan == 'zh' || lan == 'en' || lan == 'my' || lan == 'zhHant' || lan == 'ja' || lan == 'ko' || lan == 'vn') {
        localStorage.setItem('lan', lan);
        this.$i18n.locale = lan;

      } else {
        this.$root.makeToast("warning", this.$t('coming_soon'));
      }
    },
    makeToast(variant = null, msg) {
      this.$bvToast.toast(msg, {
        // // title: ` ${variant || "default"}`,
        variant: variant,
        solid: true,
      });
    },
    setLang() {
      let formData = new FormData();
      formData.append('language', this.$i18n.locale == 'en' ? 'en' : 'cn');
      setLanguage(formData);
      // var self = this;
      // result.then(function () {

      // });
    },
    checkKYC() {
      if (this.userInfo.check_kyc.can_withdraw == 'approved') {
        this.$bvModal.show('withdraw');

      } else {
        this.modal = {
          title: this.$t('kyc'),
          msg: this.$t('kyc_hint'),
          action: false,
          error: true,
        };
        this.$bvModal.show('modal-errorMsg');

      }
    },
    addToCart(product, qty = 1) {
      const existing = this.cartItems.find(i => String(i.id) === String(product.id));
      if (existing) {
        existing.qty += qty;
        existing.selected = true;   // just added again: it is meant to be bought
      } else {
        this.cartItems.push({ id: String(product.id), name: product.name, price: product.price, image: product.image, descShort: product.descShort, qty,
          // shown by the new cart page (/web/new/cart); the old shop does not send them
          sku: product.sku || '', variant: product.variant || '', originalPrice: product.originalPrice || null,
          category: product.category || '', variants: [], available: null, inactive: false, selected: true,
          // a line for one option of an item has the key "106:3"; these say which item and option
          item_id: product.item_id || product.id, variant_id: product.variant_id || null });
      }
      localStorage.setItem('shopCart', JSON.stringify(this.cartItems));
    },
    // after changing cart lines in place (new cart page: refresh from the server, tick boxes, variants)
    saveCart() {
      localStorage.setItem('shopCart', JSON.stringify(this.cartItems));
    },
    // ids are compared as text: the wishlist sent numbers, the product pages send "106" / "106:3"
    removeFromCart(id) {
      this.cartItems = this.cartItems.filter(i => String(i.id) !== String(id));
      localStorage.setItem('shopCart', JSON.stringify(this.cartItems));
    },
    updateCartQty(id, qty) {
      const item = this.cartItems.find(i => String(i.id) === String(id));
      if (!item) return;
      if (qty <= 0) {
        this.cartItems = this.cartItems.filter(i => String(i.id) !== String(id));
      } else {
        item.qty = qty;
      }
      localStorage.setItem('shopCart', JSON.stringify(this.cartItems));
    },
    clearErrorMsg() {
      this.$root.modal = {
        title: "",
        msg: "",
        action: false,
        error: false,
      };

    },
    updatePb() {
      var heighest = 0;
      var bottom = document.getElementsByClassName('withdraw-hint');
      var mainContent = document.getElementsByClassName('main-content');
      if (mainContent) {
        mainContent = mainContent[0];
        if (bottom) {
          for (let i = 0; i < bottom.length; i++) {
            if (bottom[i].offsetHeight > heighest) {
              heighest = bottom[i].offsetHeight;
              console.log(heighest);

            }
          }

        }
        if (mainContent)
          mainContent.setAttribute('style', 'padding-bottom:' + (heighest + 100) + 'px !important');


      }



    }
  },
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
